import PropTypes from "prop-types";

const ReturnKey = ({ className = "", type = "Default" }) => {
  return (
    <div
      className={`w-[87.5px] relative shadow-[0px_1px_0px_rgba(0,_0,_0,_0.3)] rounded-8xs bg-light-secondary-key-background h-[42px] text-center text-base text-light-text1 font-text-small ${className}`}
      data-type={type}
    >
      <div className="absolute top-[calc(50%_-_10px)] left-[21px] tracking-[-0.4px] leading-[21px]">
        return
      </div>
      <img
        className="absolute top-[calc(50%_-_16px)] left-[calc(50%_-_15.75px)] w-8 h-8 overflow-hidden hidden"
        alt=""
        src="/icon.svg"
      />
    </div>
  );
};

ReturnKey.propTypes = {
  className: PropTypes.string,

  /** Variant props */
  type: PropTypes.number,
};

export default ReturnKey;
